import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { isEqual } from 'lodash';
import { datadogRum } from '@datadog/browser-rum';

import Showing from './routes/Showing';
import ShowingEdit from './routes/ShowingEdit';
import ScheduleShowing from './routes/ScheduleShowing';
import BookShowing from './routes/BookShowing';

// Styled UI
import Provider from '@invitation-homes/styled-ui/lib/providers/Provider';
import EmitterRedirect from '@invitation-homes/styled-ui/lib/components/Router/EmitterRedirect';

// services
import { services, emitter } from './services';
import { initialize as initializeExperimentation } from './services/experimentation';

// config
import { FEATURE_FLAGS, datadogRumConfig } from './config';
import ProfileDashboardRedirect from './components/ProfileDashboardRedirect';

class App extends Component {
  state = {
    config: {
      featureFlags: FEATURE_FLAGS,
    },
    user: null,
    notifications: [],
    dismissedNotifications: new Set(),
  };

  componentDidMount() {
    if (process.env.NODE_ENV !== 'development') {
      datadogRum.init(datadogRumConfig);
    }
    // create the kameleoon client singleton and get a visitor code
    initializeExperimentation();
    emitter.on('auth', this.handleUserUpdate);
    services.auth.grant();
  }

  handleUserUpdate = (user) => {
    if (!isEqual(user, this.state.user)) {
      this.setState({ user });
    }
  };

  render() {
    const { user, config } = this.state;

    return (
      <Provider emitter={emitter} services={services} user={user} config={config}>
        <Router basename="/self-tours">
          <EmitterRedirect />
          <Switch>
            <Route exact path="/" component={ProfileDashboardRedirect} />
            <Route path="/showings" component={ProfileDashboardRedirect} />
            <Route path="/homes" component={ProfileDashboardRedirect} />
            <Route path="/showing/:id" render={({ match }) => <Redirect to={`/home/${match.params.id}`} />} />
            <Route
              path="/schedule-showing/:unit_id"
              render={({ location }) => {
                return <ScheduleShowing location={location} />;
              }}
            />
            <Route exact path="/book-showing/:unit_id" component={BookShowing} />
            <Route exact path="/home/:id" component={Showing} />
            <Route exact path="/home/:id/edit" component={ShowingEdit} />
          </Switch>
        </Router>
      </Provider>
    );
  }
}

export default App;
